import {axiosDefault} from '../lib/network';

export const verifyEmail = (code) => {
  return axiosDefault.post(`/v2/users/verify-email`, {code}).then(function (response) {
    return response.data;
  });
};
